<template>
    <div
        class="section-container"
    >
        <div
            :id="model.domId"
            class="scroll-placeholder"
        />
        <div
            v-if="model.title || model.icon"
            class="header"
        >
            <div class="header-main-content">
                <svg-inline
                    :id="iconId"
                    class="header-icon"
                    :src="model.icon"
                />
                <span class="header-text">{{ model.title }}</span>
            </div>
            <div
                v-if="model.disclaimer"
                class="disclaimer"
            >
                {{ model.disclaimer }}
            </div>
        </div>
        <div class="body">
            <story-content
                v-if="$screens.mobile"
                class="text-block"
                :story-content="model.storyContent"
                :placeholders="{'[localName]': model.localName}"
            />
            <speech-bubble-container
                v-if="model.primaryBeliefMetricModel && $screens.mobile"
                class="speech-bubble-container wide"
                :model="model.primaryBeliefMetricModel"
            />
            <div class="chart-group">
                <div
                    v-for="(mm, i) in model.metricModels"
                    :key="i"
                    :class="{
                        'chart': true
                    }"
                >
                    <generic-metric-chart-container
                        :id="mm.id"
                        :model="mm"
                    />
                </div>
            </div>
            <div class="story-content">
                <speech-bubble-container
                    v-if="model.primaryBeliefMetricModel && !$screens.mobile"
                    class="speech-bubble-container wide"
                    :model="model.primaryBeliefMetricModel"
                />
                <quote-container
                    v-if="model.inspirationalQuote && !$screens.mobile"
                    :quote="model.inspirationalQuote"
                />
                <story-content
                    v-if="!$screens.mobile"
                    class="text-block"
                    :story-content="model.storyContent"
                    :placeholders="{'[localName]': model.localName}"
                />
                <div
                    v-if="model.linkedTo && model.linkedTo.length > 0"
                    class="linked-to"
                >
                    {{ model.negativeTitle }} is linked to
                    <ul class="linked-to-list">
                        <li
                            v-for="(item, i) in model.linkedTo"
                            :key="i"
                        >
                            <svg-inline
                                class="list-icon"
                                src="list_icon"
                            />
                            <div>
                                {{ item }}
                            </div>
                        </li>
                    </ul>
                </div>
                <quote-container
                    v-if="model.inspirationalQuote && $screens.mobile"
                    :quote="model.inspirationalQuote"
                />
                <a
                    v-if="model.communityStoriesLink"
                    :class="`dh-button secondary ${!model.communityStoriesLink ? 'disabled' : ''}`"
                    target="_blank"
                    :href="model.communityStoriesLink"
                ><span>Get Inspired</span></a>
                <a
                    v-if="model.takeActionLink"
                    :class="`dh-button primary ${!model.takeActionLink ? 'disabled' : ''}`"
                    target="_blank"
                    :href="model.takeActionLink"
                ><span>Take Action</span></a>
            </div>
        </div>
    </div>
</template>

<script>
import GenericMetricChartContainer from '@/views/containers/GenericMetricChartContainer.vue';
import SpeechBubbleContainer from '@/views/containers/SpeechBubbleContainer.vue';
import QuoteContainer from '@/views/containers/QuoteContainer.vue';
import StoryContent from '@/components/StoryContent.vue';
import SvgInline from '@/components/SvgInline.vue';

import SectionModel from '@/model/SectionModel';

export default {
    components: {
        GenericMetricChartContainer,
        SpeechBubbleContainer,
        QuoteContainer,
        StoryContent,
        SvgInline
    },
    props: {
        model: {
            type: SectionModel,
            required: true
        }
    },
    data() {
        return {
            showMore: false
        };
    },
    computed: {
        storyParagraphs() {
            return this.model.storyContent.split('\n');
        },
        iconId() {
            return this.model.icon;
        }
    }
};
</script>

<style src="./common.tab.css" scoped></style>
<style src="./common.section.css" scoped></style>
<style lang="postcss" scoped>
.disclaimer {
    @apply text-xs py-2 opacity-50;
}
.header-icon {
    @apply  inline-flex items-center;
}

.header-text {
    @apply inline-block relative;
    bottom: 24px;
}

@screen mobile {
    .header-text {
        top: 8px;
        bottom: 0;
    }
    .header-main-content {
        display: flex;
        align-items: center;
    }
}

.list-icon {
    height: 24px;
    width: 24px;
}
.list-icon >>> svg {
    height: 24px;
    width: 24px;
    margin: -1px 0 0 0;
}
</style>
<style lang="postcss">
.header-main-content .svg-inline {
    @apply mx-0 -ml-2 inline-flex items-center w-16 h-16;
}
</style>
